module.exports = __webpack_public_path__ + "img/dis-yipaiqian.63912333.svg";